import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const RedirectsIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.293 13.293a1 1 0 0 1 1.338-.068l.076.068 3 3a1 1 0 0 1 0 1.414l-3 3a1 1 0 1 1-1.414-1.414L18.586 18H3a1 1 0 1 1 0-2h15.586l-1.293-1.293-.068-.076a1 1 0 0 1 .068-1.338m-12-10a1 1 0 1 1 1.414 1.414L5.414 6H21a1 1 0 1 1 0 2H5.414l1.293 1.293.068.076a1 1 0 0 1-1.406 1.406l-.076-.068-3-3a1 1 0 0 1 0-1.414z"
      ></path>
    </Icon>
  );
};
